import { Component, Inject, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CaracteristicaCodigoEquipoService } from '@services/catalogo/caracteristicaCodigoEquipo.service';
import { ValidatorsService } from '@services/util/validators.service';
import { Util } from '@/utils/util';
import { CaracteristicaCodigoEquipoModel } from '@/store/catalogos/caracteristicaCodigoEquipo';
import { FormularioCodigoEquipoCaracteristicaEditarComponent } from '../formulario-codigo-equipo-caracteristica-editar/formulario-codigo-equipo-caracteristica-editar.component';

@Component({
  selector: 'app-formulario-codigo-equipo-caracteristica',
  templateUrl: './formulario-codigo-equipo-caracteristica.component.html',
  styleUrls: ['./formulario-codigo-equipo-caracteristica.component.scss']
})
export class FormularioCodigoEquipoCaracteristicaComponent {
  title: string = "Característica de inspección";
  form: FormGroup;
  mostrarBoton: boolean = true;
  displayedColumns: string[] = ['caracteristicas', 'realizo', 'options'];
  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private catalogoService: CaracteristicaCodigoEquipoService,
    public dialogRef: MatDialogRef<any>,
    public dialog: MatDialog,
    private validatorsService: ValidatorsService,
    private util: Util,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  ngOnInit() {
    this.buildForm(this.data?.row);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.loadCaracteristicaCodigoEquipos();
  }

  private buildForm(data: CaracteristicaCodigoEquipoModel): void {
    this.form = new FormGroup({
      idCaracteristica: new FormControl(data?.idCaracteristica ?? null),
      caracteristicas: new FormControl(data?.carateristica ?? '', [Validators.required, Validators.maxLength(250)]),
      realizo: new FormControl(data?.realiza ?? '', [Validators.required, Validators.maxLength(25)])
    });

    if (this.data.view) {
      this.form.disable();
      this.mostrarBoton = false;
    }
  }

  isValidField(field: string): boolean {
    return this.form?.controls[field]?.invalid && this.form?.controls[field]?.touched;
  }

  getFieldError(field: string): string {
    return this.validatorsService.getFieldError(this.form, field);
  }

  enviar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const caracteristica: CaracteristicaCodigoEquipoModel = this.formToModel();
    const request = this.data.insert
      ? this.catalogoService.create(caracteristica)
      : this.catalogoService.update(caracteristica);


    request.subscribe(response => {
      if (response.success) {
        this.util.successMessage("Registro guardado con éxito!");
        // this.dialogRef.close({ data: response });
        this.loadCaracteristicaCodigoEquipos();
      } else {
        const errorMsg = this.util.isEmpty(response.message)
          ? "Ocurrió un error al guardar el registro"
          : response.message;
        this.util.errorMessage(errorMsg);
      }
    });
  }

  private formToModel(): CaracteristicaCodigoEquipoModel {
    const formValues = this.form.getRawValue();

    return {
      idCaracteristica: formValues.idCaracteristica ?? '',
      carateristica: formValues.caracteristicas ?? '',
      realiza: formValues.realizo ?? '',
      equipo: {
        idCodigoEquipo: this.data.row.idCodigoEquipo ?? ''
      }
    };
  }

  loadCaracteristicaCodigoEquipos() {
    this.catalogoService.getIdEquipo(this.data.row.idCodigoEquipo).subscribe(data => {
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });

  }

  update(row: CaracteristicaCodigoEquipoModel) {
    const dialogRef = this.dialog.open(FormularioCodigoEquipoCaracteristicaEditarComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
      disableClose: true, data: { insert: false, update: true, view: false, row: row }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadCaracteristicaCodigoEquipos();
      }
    });
  }

}
